<template>
<v-expansion-panel focusable>
    <v-expansion-panel-content v-for="(item, i) in categories" :key="i">
        <template v-slot:actions>
            <v-icon color="primary">$vuetify.icons.expand</v-icon>
        </template>
        <template v-slot:header>
            <div>
                <v-btn icon color="error" v-if="getCategoryCount(item.Category, 'critical') > 0">{{ getCategoryCount(item.Category, 'critical') }}</v-btn>
                <v-btn icon color="warning" v-if="getCategoryCount(item.Category, 'warnings') > 0">{{ getCategoryCount(item.Category, 'warnings') }}</v-btn>
                <v-btn icon color="info" v-if="getCategoryCount(item.Category, 'notices') > 0">{{ getCategoryCount(item.Category, 'notices') }}</v-btn>
                <span>{{ item.Category }}</span>
            </div>
        </template>
        <div class="alert-content">
            <v-list dense>
                <v-list-tile v-for="(alert, j) in item.Alerts" :key="j" @click="navigate(alert.Url)">
                    <v-list-tile-content>
                        <v-list-tile-title v-text="alert.Message"></v-list-tile-title>
                    </v-list-tile-content>
                    <v-list-tile-action v-if="alert.Url">
                        <v-icon color="primary">play_arrow</v-icon>
                    </v-list-tile-action>
                </v-list-tile>
            </v-list>
            <v-btn v-if="showMore" color="primary" @click="showAlerts(item.Priority)">More</v-btn>
        </div>
    </v-expansion-panel-content>
</v-expansion-panel>
</template>

<script>
export default {
    props: ['alerts', 'categoryTotals', 'showMore'],
    data() {
        return {}
    },
    computed: {
        categories() {
            let categories = [];

            this.alerts.forEach(alert => {
                let found = categories.find(item => {
                    return item.Category == alert.Category
                });

                if (!found) {
                    categories.push({
                        "Category": alert.Category,
                        "Priority": alert.Priority,
                        "Alerts": [alert]
                    });
                } else {
                    found.Alerts.push(alert);
                }
            });

            return categories;
        }
    },
    methods: {
        navigate(url) {
            if(url) {
                this.$store.commit("GeneralStore/setLoadingRoute", true);
                window.location.href = "/" + process.env.VUE_APP_OLD_HMS_ROOT + "/" + url
            }
        },
        getCategoryCount(category, alertType) {
            let total = 0;

            this.categoryTotals.forEach(cat => {
                if(cat.Category == category) {
                    if(alertType == "critical") {
                        total = cat.TotalCriticals;
                    } else if(alertType == "warnings") {
                        total = cat.TotalWarnings;
                    } else if(alertType == "notices") {
                        total = cat.TotalNotices;
                    }
                }
            });

            return total;
        },
        showAlerts(priority) {
            // Emit event on global event bus.  These events are handled in the AlertNotifications component
            if(priority == 1) {
                this.$root.$emit("showAlerts", 'tab-critical')
            } else if(priority == 2) {
                this.$root.$emit("showAlerts", 'tab-cautions')
            } else {
                this.$root.$emit("showAlerts", 'tab-notices')
            }
        }
    }
}
</script>

<style scoped>
.alert-content {
    max-height: 300px;
    overflow-y: scroll;
}
.v-expansion-panel >>> .v-expansion-panel__header {
    padding-top: 6px;
    padding-bottom: 6px;
    padding-left: 12px;
    padding-right: 12px;
}
</style>
